"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M252.356 1468.235c53.76-59.971 86.513-139.143 86.513-225.882V847.059c0-342.55 278.626-621.177 621.176-621.177 342.438 0 621.177 278.626 621.177 621.177v395.294c0 86.739 32.753 165.91 86.4 225.882H252.356zm707.69 338.824c-124.575 0-225.883-101.308-225.883-225.883h451.765c0 124.575-101.309 225.883-225.883 225.883zm734.117-564.706V847.059c0-385.694-299.294-702.268-677.647-731.294V0H903.575v115.765c-378.466 29.026-677.647 345.6-677.647 731.294v395.294c0 124.574-101.309 225.882-225.883 225.882v112.941h621.177c0 186.805 151.906 338.824 338.823 338.824 186.805 0 338.824-152.019 338.824-338.824h621.176v-112.94c-124.574 0-225.882-101.309-225.882-225.883z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAlerts =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconAlerts, _Component);

  function IconAlerts() {
    (0, _classCallCheck2.default)(this, IconAlerts);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconAlerts).apply(this, arguments));
  }

  (0, _createClass2.default)(IconAlerts, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconAlerts",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconAlerts.displayName = "IconAlerts";
  return IconAlerts;
}(_react.Component);

exports.default = IconAlerts;
IconAlerts.glyphName = 'alerts';
IconAlerts.variant = 'Line';
IconAlerts.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);